import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/database'
import Config from '../config'

firebase.initializeApp(Config.firebase)

export default firebase
